﻿/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface IGisDataStoreMetadataMappingScope extends angular.IScope {
        model: warsApp.models.GisDataStoreMetadataMappingModel;
    }

    export class GisDataStoreMetadataMappingController implements IController {
        constructor(scope: IGisDataStoreMetadataMappingScope,
            $routeParams: angular.route.IRouteParamsService,
            gisDatastoreMetadataMappingService: services.GisDataStoreMetadataMappingService,
            gisDatastoreService:services.GisDatastoreService,
            treeService:services.TreeService,
            $q:angular.IQService) {
            let processConfigurationId = $routeParams["id"];
            scope.model = new models.GisDataStoreMetadataMappingModel(processConfigurationId, gisDatastoreMetadataMappingService,gisDatastoreService,treeService,$q);
        }
    }
}

warsApp.registerController('GisDataStoreMetadataMappingController',
    ['$scope', '$routeParams', 'gisDataStoreMetadataMappingService','gisDatastoreService','treeService','$q']);